import React from 'react';
import { 
  Button as MuiButton, 
  styled 
} from '@mui/material';

const StyledButton = styled(MuiButton)(({ theme, size }) => ({
  borderRadius: '8px',
  boxShadow: 'none',
  textTransform: 'none',
  fontWeight: 600,
  ...(size === 'small' && {
    padding: '6px 12px',
    fontSize: '0.8125rem',
  }),
  ...(size === 'medium' && {
    padding: '8px 16px',
    fontSize: '0.875rem',
  }),
  ...(size === 'large' && {
    padding: '10px 22px',
    fontSize: '0.9375rem',
  }),
}));

const Button = ({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  startIcon,
  endIcon,
  fullWidth = false,
  onClick,
  disabled = false,
  component,
  className,
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      color={color}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      fullWidth={fullWidth}
      onClick={onClick}
      disabled={disabled}
      component={component}
      className={className}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
